import React from 'react';
import 'twin.macro';

export function BreadcrumbDivider() {
  return (
    <svg
      width="6"
      height="15"
      viewBox="0 0 6 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      tw="mx-1 text-neutral-supershy"
    >
      <path
        d="M5.80682 0.318181L2.05682 14.25H0.255682L4.00568 0.318181H5.80682Z"
        fill="currentColor"
      />
    </svg>
  );
}
